module.exports = __webpack_public_path__ + "media/images/athletes/1648-338bd88994f9867a3f523ff520ef7a96.png";